var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":!_vm.modal.canCloseOutside,"max-width":_vm.modal.size,"content-class":`${_vm.modal.withoutShadow ? 'modal--without-shadow' : ''}`},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(_vm.modal.name,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }